


































import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Home extends Vue {
  public activeMenu = "";
  // public mounted() {}
  public toJumpCustomer() {
    this.$router.push({path: "/aboutUS", query: {
      type: "contact"
    }})
  }
}
